import { Loading } from '@/shared/ui';
import { KnowledgeFilesWorkspace } from '@/features/knowledge-bases';
import { useCurrentWorkspaceId } from '@/entities/workspace';

export const KnowledgeBase = () => {
  const workspaceId = useCurrentWorkspaceId();

  if (!workspaceId) {
    return <Loading />;
  }

  return <KnowledgeFilesWorkspace />;
};

KnowledgeBase.displayName = 'KnowledgeBase';
